import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import GroupedSelect from "../../grouped-select";
import {RENDERER_TYPES} from "../constants";

export const GroupedSelectTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.groupedSelect);

export const GroupedSelectRenderer = withJsonFormsControlProps(
  ({data, handleChange, path, label, schema, id, required, errors}) => {
    const isError = Boolean(errors && errors.length > 0);

    return (
      <GroupedSelect
        id={id}
        items={schema.elements ?? []}
        idKey="__Guid"
        labelKey="title"
        parentKey="parent"
        value={data}
        onChange={newValue => handleChange(path, newValue)}
        label={label}
        required={required}
        error={isError}
        helperText={isError ? errors : undefined}
      />
    );
  }
);
